import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/Icon";
import { PageHero } from "@/components/PublicLayout";
import { Reveal } from "@/components/Reveal";
import { CTABanner } from "@/components/CTABanner";
import { COMPANY } from "@/lib/data";

const ways = [
  { icon: "Handshake", title: "Broker-Arranged Transportation", text: "Trips arranged through your insurance or transportation broker. We coordinate directly with your broker." },
  { icon: "Buildings", title: "Facility-Arranged Transportation", text: "Your hospital, treatment center, day program, or care facility schedules transportation on your behalf." },
  { icon: "CreditCard", title: "Private Pay Transportation", text: "Reliable rides you can arrange directly for yourself or a loved one, outside of broker-arranged trips." },
  { icon: "UsersThree", title: "ODP / Community Transportation", text: "Transportation supporting day programs, employment, and approved community participation." },
];

export default function ForClients() {
  return (
    <>
      <PageHero
        eyebrow="For Clients"
        title="Need a Ride?"
        subtitle="There are several ways transportation with CareDeserved can be arranged. Here's how to get where you need to go."
      />
      <section className="bg-white py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-6 sm:grid-cols-2">
            {ways.map((w, i) => (
              <Reveal key={w.title} delay={i * 0.06}>
                <div className="flex h-full gap-5 rounded-2xl border border-slate-200 bg-brand-bg p-7">
                  <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-brand-blue/5 text-brand-blue">
                    <Icon name={w.icon} size={28} weight="duotone" />
                  </span>
                  <div>
                    <h3 className="font-heading text-lg font-semibold text-slate-900">{w.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-slate-600">{w.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="mt-14 grid items-center gap-8 rounded-3xl bg-brand-teal p-8 sm:p-12 lg:grid-cols-[1.4fr_1fr]">
            <div>
              <h2 className="font-heading text-2xl font-bold text-white sm:text-3xl">Already scheduled with CareDeserved?</h2>
              <p className="mt-3 text-teal-50 md:text-lg">
                When your appointment is complete, contact your assigned driver for your return ride. If you are unable
                to reach your driver, call our main office and we'll help right away.
              </p>
            </div>
            <a href={COMPANY.phoneHref} className="flex items-center justify-center gap-3 rounded-2xl bg-white px-6 py-5 text-center shadow-lg">
              <Icon name="Phone" size={26} weight="fill" className="text-brand-teal" />
              <span>
                <span className="block text-xs font-semibold uppercase tracking-wide text-slate-500">Main Office</span>
                <span className="font-heading text-2xl font-bold text-brand-blue">{COMPANY.phone}</span>
              </span>
            </a>
          </div>

          <div className="mt-14 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
            <Link to="/book-a-ride"><Button data-testid="clients-book" className="h-13 rounded-full bg-brand-purple px-8 py-3 font-semibold text-white hover:bg-brand-purple2">Book a Ride</Button></Link>
            <Link to="/private-pay"><Button data-testid="clients-quote" variant="outline" className="h-13 rounded-full border-brand-blue px-8 py-3 font-semibold text-brand-blue hover:bg-brand-blue hover:text-white">Request a Quote</Button></Link>
          </div>
        </div>
      </section>
      <CTABanner />
    </>
  );
}
